import {WishType} from "../wish/Helper";

export interface IHomeState {
    loading: boolean
    content: IHomeStaticInformation
}

export interface IHomeStepsByType {
    [WishType.DRAW]: IHomeSteps[]
    [WishType.VOUCHER]: IHomeSteps[]
}

export interface IHomeHowItWorks {
    subtitle_en: string
    subtitle_mk: string
    subtitle_al: string
    steps: IHomeStepsByType
}

export interface IHomeStaticInformation {
    slogan_en: string
    slogan_mk: string
    slogan_al: string
    carousel: IHomeCarousel[]
    why_genie: IHomeWhyGenie[]
    how_it_works: IHomeHowItWorks

    [key: string]: any
}

export interface IHomeCarousel {
    text_en: string
    text_mk: string
    text_al: string
    image: string
    link: string

    [key: string]: any
}

export interface IHomeSteps {
    label_en: string
    label_mk: string
    label_al: string

    [key: string]: any
}

export interface IHomeWhyGenie {
    title_en: string
    title_mk: string
    title_al: string
    subtitle_en: string
    subtitle_mk: string
    subtitle_al: string
    icon: string

    [key: string]: any
}

export const initialHomeStaticInformationState: IHomeStaticInformation = {
    slogan_en: "",
    slogan_mk: "",
    slogan_al: "",
    carousel: [],
    why_genie: [],
    how_it_works: {
        subtitle_en: "",
        subtitle_mk: "",
        subtitle_al: "",
        steps: {
            [WishType.DRAW]: [],
            [WishType.VOUCHER]: [],
        },
    },
}

export const normalizeHomeStaticInformation = (value: any): IHomeStaticInformation => {
    const raw = value ?? {};
    return {
        ...initialHomeStaticInformationState,
        ...raw,
        how_it_works: {
            ...initialHomeStaticInformationState.how_it_works,
            ...raw.how_it_works,
            steps: {
                [WishType.DRAW]: Array.isArray(raw?.how_it_works?.steps?.[WishType.DRAW]) ? raw.how_it_works.steps[WishType.DRAW] : [],
                [WishType.VOUCHER]: Array.isArray(raw?.how_it_works?.steps?.[WishType.VOUCHER]) ? raw.how_it_works.steps[WishType.VOUCHER] : [],
            },
        },
    };
}

export const getRandomWhyGenieArray = (): IHomeWhyGenie[] => {
    const arr: IHomeWhyGenie[] = []
    for (let i = 0; i < 4; i++) {
        arr.push(
            {
                title_mk: i.toString(), title_en: i.toString(), title_al: i.toString(),
                subtitle_mk: "", subtitle_en: "", subtitle_al: "", icon: ""
            }
        )
    }

    return arr
}
